// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueResourse from 'vue-resource'
import VueAMap from 'vue-amap';
Vue.use(VueResourse);

import axios from 'axios'
Vue.prototype.$axios = axios

/* import Video from 'video.js'
import 'video.js/dist/video-js.css'
Vue.prototype.$video = Video */

import echarts from 'echarts'
Vue.prototype.$echarts = echarts;
Vue.config.silent = true//屏蔽警告信息
//引入 iview
import iView from 'iview';
import 'iview/dist/styles/iview.css';

Vue.use(iView);

//引入地图
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: '3805e952cd3595ff583c8e3c1db1a0a9',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4'
});
Vue.prototype.$Message.config({
  top: 70,
  duration:2
});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js